import { parseAssortmentId } from "helpers/product-collection";
import me from "models/me";

export default function (nextState, replace, callback) {
    const brandRollupPathname = `/assortment/${nextState.params.id}/shop/brand/${me.last_brand}`;

    if (me.isBrandUser() && !parseAssortmentId(nextState.params.id).isRollupMode) {
        replace({
            pathname: brandRollupPathname,
        });
    }

    callback();
}
